




import Vue from "vue";
import ContractorsSummaryRoleComponentSelector from "./ContractorsSummaryRoleComponentSelector.vue";
import { icons } from "@/utils";
import { ISummaryVue } from "../../../../components/Summary/mixins/ISummaryVue";
import { ISummaryRowEntity } from "@/components/Summary/Row/mixins/ISummaryRowEntity";
import { IRowMeta } from "@/components/Summary/Row/mixins/IRowMeta";
import { IResolvedPermissions } from "@/components/Summary/IResolvedPermissions";

export default Vue.extend({
  name: "ContractorsMenuList",

  components: {
    ContractorsSummaryRoleComponentSelector,
  },

  created(this: ISummaryVue<ISummaryRowEntity, unknown, IRowMeta, IResolvedPermissions>) {
    this.$store.commit("header/title", {
      context: this,
      faIcon: icons.contractors,
      text: this.recruitmentAgencySettings.customisation.contractor.name.plural.initialUpper,
    });
  },
});
